export const formatNumber = (num) =>
  num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

export const toNumber = (str = "") => Number(str.replace(/[^0-9.-]+/g, ""));
